import { createSelector } from "reselect";
import { User } from "./user.model";
import * as fromUserActions from "./user.actions";
import { handleRemoveAction, handleSetFilterAction, handleSubmitAction } from "../../../core/store/helpers/reducer-helper";
import { BaseObjectFilters } from "../../store/bootstrap";

export interface UserFilters extends BaseObjectFilters {
    accessGroup: string;
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: User };
    selected: string;
    filters: UserFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    selected: undefined,
    filters: {
        searchTerm: "",
        accessGroup: "*",
        sortBy: "name",
        sortDirection: 1
    }
};

export function reducer(state = initialState, action: fromUserActions.Actions): State {
    switch (action.type) {
        case fromUserActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromUserActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromUserActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        case fromUserActions.SELECT: {
            return {
                ...state,
                selected: action.payload ? action.payload : undefined
            };
        }
        default: {
            return state;
        }
    }
}

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const getEntities = (state: State) => state.entities;

export const getIds = (state: State) => state.ids;

export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map(id => entities[id]));



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.reducer.ts